function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function triggerElementEvent(ele, type) {
  let event
  // IE9+ and other modern browsers
  if (document.createEvent) {
    event = document.createEvent("HTMLEvents")
    event.initEvent(type, false, true)
    event.eventName = type
    ele.dispatchEvent(event)
  } else {
    // IE8
    event = document.createEventObject()
    event.eventName = type
    event.eventType = type
    ele.fireEvent("on" + event.eventType, event)
  }
}

class Filters extends HTMLElement {
  constructor() {
    super()

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 600)

    this.form = this.querySelector("form")
    this.form.addEventListener("input", this.debouncedOnSubmit.bind(this))
  }

  renderPage(searchParams, event, updateURLHash = true) {
    Filters.searchParamsPrev = searchParams
    const sections = Filters.getSections()

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      Filters.filterData.some(filterDataUrl)
        ? this.renderSectionFromCache(filterDataUrl, event)
        : this.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) Filters.updateURLHash(searchParams)
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = Filters.filterData.find(filterDataUrl).html
    Filters.renderFilters(html, event)
    this.renderPageContent(html)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = response
        Filters.filterData = [...Filters.filterData, { html, url }]
        Filters.renderFilters(html, event)
        this.renderPageContent(html)
      })
  }

  renderPageContent(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html")

    const sections = Filters.sectionToRender()

    sections.forEach((section) => {
      const source = parsedHTML.getElementById(section.id) || parsedHTML.querySelector(section.selector)
      const destination = document.getElementById(section.id) || document.querySelector(section.selector)

      if (source) {
        destination.innerHTML = source.innerHTML
      }
    })

    this.removeLoading()
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`)
  }

  static sectionToRender() {
    return [
      {
        id: "ProductGridContainer",
      },
      {
        selector: ".filter-by__active-list",
      },
    ]
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ]
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html")
    const filterDetails = parsedHTML.querySelectorAll("#FiltersForm .js-filter")

    const matchIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }

    const filterToRender = Array.from(filterDetails).filter((element) => !matchIndex(element))

    filterToRender.forEach((element) => {
      const destination = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`)
      const isOpen = destination.hasAttribute("open")

      destination.replaceWith(element)

      if (isOpen) {
        const destination = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`)
        destination.isOpen = "true"
        destination.buttonOpen = "true"
      }
    })
  }

  setLoading() {
    this.querySelector(".filter-by__form").classList.add("loading")
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading")
  }

  removeLoading() {
    this.querySelector(".filter-by__form").classList.remove("loading")
  }

  onSubmitHandler(event) {
    event.preventDefault()

    console.log("THIS IS RUNNING")

    const formData = new FormData(this.form)
    const searchParams = new URLSearchParams(formData).toString()
    this.setLoading()
    this.renderPage(searchParams, event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    const url =
      event.currentTarget.href.indexOf("?") === -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1)
    this.renderPage(url)
  }
}

Filters.filterData = []
Filters.searchParamsInitial = window.location.search.slice(1)
Filters.searchParamsPrev = window.location.search.slice(1)
customElements.define("filters-form", Filters)

class FilterRemove extends HTMLElement {
  constructor() {
    super()
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault()
      document.querySelector("sort-select").reset()
      const form = this.closest("filters-form") || document.querySelector("filters-form")
      form.onActiveFilterClick(event)
    })
  }
}

customElements.define("filters-remove", FilterRemove)

class FilterMenu extends HTMLElement {
  constructor() {
    super()
    this.drawer = this
    const toggleButton = document.querySelector("[data-mobile-filter-open]")
    toggleButton.addEventListener("click", this.toggle.bind(this))

    this.closeButton = this.querySelector("[data-mobile-filter-close]")
    this.closeButton.addEventListener("click", this.toggle.bind(this))

    this.applyButton = this.querySelector(".mobile-filter__action-apply")
    this.applyButton.addEventListener("click", this.toggle.bind(this))
  }

  toggle() {
    this.drawer.classList.toggle("is-open")
  }
}

customElements.define("filter-drawer", FilterMenu)

// Price Slider
class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector(".filter-by__price-slider")
    this.priceInputs = this.querySelectorAll(".filter-by__price-input input")
    this.initializeNoUi()
    this.initializeInputListener()
  }

  initializeNoUi() {
    const slider = this.slider
    const priceInput = this.priceInputs

    noUiSlider.create(slider, {
      start: [Number(slider.dataset.currentMinValue), Number(slider.dataset.currentMaxValue)],
      connect: true,
      step: 1,
      tooltips: {
        to: function (value) {
          return "$" + Math.round(value)
        },
      },
      margin: 10,
      range: {
        min: Number(slider.dataset.min),
        max: Number(slider.dataset.max),
      },
    })

    slider.noUiSlider.on("change", (values, handle) => {
      priceInput[handle].value = values[handle]

      console.log(values)

      if (values[0] <= Number(slider.dataset.min) && values[1] >= Number(slider.dataset.max)) {
        priceInput[0].disabled = true
        priceInput[1].disabled = true
      } else {
        priceInput[0].disabled = false
        priceInput[1].disabled = false

        triggerElementEvent(priceInput[handle], "change")
      }
    })
  }

  initializeInputListener() {
    this.priceInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.slider.closest("filters-form").onSubmitHandler(event)
      })
    })
  }
}

customElements.define("price-range", PriceRange)

class SortSelect extends HTMLElement {
  constructor() {
    super()
    this.select = this.querySelector("select")
    this.select.addEventListener("change", this.handleChange.bind(this))
  }

  reset() {
    this.querySelector("select").value = "manual"
  }

  handleChange(event) {
    const value = this.select.value
    const inputSelect = document.querySelector('input[name="sort_by"]')
    inputSelect.value = value

    console.log(inputSelect)

    document.querySelector("filters-form").onSubmitHandler(event)
  }
}

customElements.define("sort-select", SortSelect)
